module.exports = "<hybse-admin-page-categor-create [actionType]=\"'edit'\">\n\n</hybse-admin-page-categor-create>\n"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/page-cat/page-cat-update/page-category-update.component.html
// module id = ../../../../../src/app/components/pages/page-cat/page-cat-update/page-category-update.component.html
// module chunks = main